import type { FaireProductEntity } from "../../entity_types/product";

export const p_ybbaxqjvwk: FaireProductEntity = {
  token: "p_ybbaxqjvwk",
  type: "product",
  name: "Manon Tee ( 2XS/S - 2M/L )",
  brandToken: "b_85a3118wke",
  brandName: "Le Bon Shoppe",
  imageUrl:
    "https://cdn.faire.com/fastly/75b3ab90481dcd1fd5ab1c9c09d345ff5661b5d63dcaedd5b39853b571ce02ee.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/89381947b57e591f1ebf3f85f2e357156c443c00e017dcff5ec493c361b3e9a9.jpeg",
    "https://cdn.faire.com/fastly/8e2c38e9fc22d709d0de4a15a3d099bcc4dfd2633d704aef9e76bc35a8d3b84c.jpeg",
    "https://cdn.faire.com/fastly/fcef4d94ba472b12b4196dcb63c9136ecb9fd6373fe2a5ec31b7f711763eff04.jpeg",
    "https://cdn.faire.com/fastly/731aea146d4f9a3003e5415b1e8d4037d2c3808f7a442cf60571f027a1c29c42.jpeg",
    "https://cdn.faire.com/fastly/1b57fb0cc9a743ac0c8b9c72bac0c26f469012c2bd519af35e4c091b85968800.jpeg",
    "https://cdn.faire.com/fastly/fc067c13e5e0c71bc18b63306b6e7087511b941229801e9a7c07b1c21a5399a6.jpeg",
    "https://cdn.faire.com/fastly/f5dd4e4e48f797927f579771172ba67f5fe02d853ce0e33684db03cd65629a6a.jpeg",
    "https://cdn.faire.com/fastly/2991d22af17f3813ec523332c87c7c1be16debc6bb26487b619e7fc34b5366f7.jpeg",
    "https://cdn.faire.com/fastly/50b2e6f5767ece26da4e2f25e92dfa00b6941a7f21359ffc13ddeff9d0553057.jpeg",
    "https://cdn.faire.com/fastly/5fd9a20a637d8fdbd0e23c347df7a0b913900ea23ea9045e5cd81b92fc9b4b33.jpeg",
    "https://cdn.faire.com/fastly/78bdef9eb2541e3e495197c6fcb52fda6a0333a808873748fa9341411a3b0ce8.jpeg",
  ],
  priceDollars: 160,
  description:
    'Why We Made This?\n\nA shorter take on a classic. The Manon Tee channels the same effortless charm as the Marseille Top, reimagined with a cap sleeve and cropped length. Made from the same substantial heavyweight cotton, it holds its boxy shape while feeling soft against the skin. Finished with Parisian-inspired stripes, it’s an easygoing essential with timeless appeal.\n\n\n\nContents: \n\n100% Cotton Heavy Cotton Stripe\n\n\n\nCare Instructions:\n\n-Machine wash cold with like colors\n-Do not soak\n-Do not spot clean\n-Hang dry for best results or tumble dry on low heat\n\n\n\n\nApproximate Measurements: \n\n\nXS/S : Chest 22", Length 21 1/2"\n\n\nM/L : Chest 23 1/2", Length 22"\n\n\n\nModel is 5\' 6", Bust: 34", Waist: 27", Hip:36" and wearing a size XS/S\n\n\n\nMade in South Korea \n\n\n\nMSRP: $79 USD\n\n\n\n\n\n\n\n',
  tags: [],
  msrpDollars: 316,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-04-21T21:52:10.307Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
